import service from '@/store/services/autorizaciones-service';
import Jsona from 'jsona';

const jsona = new Jsona();

export const state = () => ({
  list: {},
  autorizacion: {},
  meta: {},
  url: null
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, autorizacion) => {
    state.autorizacion = autorizacion;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  }
};

export const actions = {
  list({commit, dispatch}, params = {}) {
    return service.list(params, this.$axios)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  token({commit, dispatch}, params) {
    return service.token(params, this.$axios)
      .then((autorizacion) => { commit('SET_RESOURCE', autorizacion); });
  },
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.total, 
  token: state => state.autorizacion,
  autorizacion: state => state.autorizacion,
  url: state => state.url
};

const autorizaciones = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default autorizaciones;
